// extracted by mini-css-extract-plugin
export default {"spinner":"spinner--vWl6X","mark":"mark--HqXH0"};